export function makeConsensusService(consensisAPIResponse) {
    return new window.F.service.Consensus({
        name: consensisAPIResponse.stage,
        consensusGroup: consensisAPIResponse.name,
        worldId: consensisAPIResponse.worldId,
    });
}



// WEBPACK FOOTER //
// ./src/channels/route-handlers/epicenter-route-handlers/world-route-handler/consensus-route-handler/consensus-utils.js